import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=d7f3513c&scoped=true&lang=pug&"
import script from "./QRCode.vue?vue&type=script&lang=ts&"
export * from "./QRCode.vue?vue&type=script&lang=ts&"
import style0 from "./QRCode.vue?vue&type=style&index=0&id=d7f3513c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f3513c",
  null
  
)

export default component.exports